import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { feedBackList, notAttendedReasons, rejectReasons } from "./common/constants";
import { updateRequests } from "./common/apiCalls";
import { toast } from "react-toast";
import moment from "moment";
import { EVENTS } from "./events_constant";
import { event } from "clevertap-react";
import { logEventToAnalyticsPlatform } from "../../helper/events";

export default function ActionsDialog({
  action,
  appointmentDate,
  requestId,
  speciality,
  patientName,
  actionDialogVisible,
  setActionDialogVisibility,
  fetchData,
  setFetchData,
  currentProvider,
  pmEntityId,
}) {
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [remark, setRemark] = useState("");
  const [feedback, setFeedback] = useState("");

  const updateRequest = async () => {
    try {
      let feedbackToUpdate = null;
      let updateRequestRemark = "";
      if (requiredAction.reasonRequired) {
        if (reason === "Others") {
          updateRequestRemark = "Others - " + otherReason;
        } else {
          updateRequestRemark = reason;
        }
      } else if (requiredAction.remarksRequired) {
        updateRequestRemark = remark;
      } 
      if(requiredAction.feedBackRequired) {
        feedbackToUpdate = feedback
      }
      setActionDialogVisibility(false);
      debugger
      let response = await updateRequests(["OFFLINE_CONSULTS"], [requestId], updateRequestRemark, action, null, null, null, feedbackToUpdate);
      if (response?.success) {
        setFetchData(!fetchData);
        toast.success("Request updated successfully");
        
        logEventToAnalyticsPlatform({
          name: EVENTS.PC_LS_ACTION.name,
          payload: {
            tab_name: EVENTS.TAB_NAME_UPCOMING_APPOINTMENTS,
            filterValue: 'true',
            reference_id: '' + pmEntityId,
            reference_provider_id: '' + currentProvider,
            service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
            action: requiredAction.eventAction,
          },
          schema: EVENTS.PC_LS_ACTION.schema,
        })
        
      } else {
        toast.error(`Request update failed - ${response?.error}`);
      }
    } catch (err) {
      toast.error(`Request update failed - ${err?.response?.data?.error}`);
    }
  };

  const actionMap = {
    Attended: {
      remarksRequired: true,
      remarksCompulsory: true,
      reasonRequired: false,
      feedBackRequired: true,
      feedBackList: feedBackList,
      buttonName: "Mark Attended",
      buttonClass: "border-green-600 bg-green-600 text-gray-100 border cursor-pointer rounded-md w-40 p-1 text-sm font-semibold",
      header: "Mark Appointment as Attended",
      eventAction: EVENTS.ACTION.ATTENDED_CLICKED
    },
    NotAttended: {
      remarksRequired: false,
      remarksCompulsory: false,
      reasonRequired: true,
      reasons: notAttendedReasons,
      feedBackRequired: false,
      buttonName: "Mark Not Attended",
      buttonClass: "border-red-600 bg-red-600 text-gray-100 border cursor-pointer rounded-md w-40 p-1 text-sm font-semibold",
      header: "Mark Appointment as Not Attended",
      eventAction: EVENTS.ACTION.NOT_ATTENDED_CLICKED
    },
    Confirm: {
      remarksRequired: true,
      remarksCompulsory: false,
      reasonRequired: false,
      feedBackRequired: false,
      buttonName: "Confirm",
      buttonClass: "border-green-600 bg-green-600 text-gray-100 border cursor-pointer rounded-md w-40 p-1 text-sm font-semibold",
      header: "Confirm Appointment",
      eventAction: EVENTS.ACTION.CONFIRM_CLICKED
    },
    Reject: {
      remarksRequired: false,
      remarksCompulsory: false,
      reasonRequired: true,
      reasons: rejectReasons,
      feedBackRequired: false,
      buttonName: "Reject",
      buttonClass: "border-red-600 bg-red-600 text-gray-100 border cursor-pointer rounded-md w-40 p-1 text-sm font-semibold",
      header: "Reject Appointment",
      eventAction: EVENTS.ACTION.REJECT_CLICKED
    },
  };
  const requiredAction = actionMap[action];

  return (
    <Dialog open={actionDialogVisible} onClose={() => setActionDialogVisibility(false)} fullWidth={true} maxWidth={"sm"}>
      <DialogTitle style={{ background: "rgb(245 245 245)" }}>
        <div className="flex justify-between">
          <div className="font-semibold">
            <span className="cursor-pointer">{requiredAction.header}</span>
            <div className="text-xs text-gray-500">
              Request ID: <span className="font-semibold">{requestId} </span>
            </div>
            <div className="text-xs text-gray-500">
              Appointment Date and Time: <span className="font-semibold">{moment(appointmentDate).format("MMMM Do YYYY hh:mm A")} </span>
            </div>
            <div className="text-xs text-gray-500">
              Speciality: <span className="font-semibold">{speciality} </span>
            </div>
            <div className="text-xs text-gray-500">
              Patient Name: <span className="font-semibold">{patientName} </span>
            </div>
          </div>
          <div className="text-gray-500" onClick={() => setActionDialogVisibility(false)}>
            <span className="cursor-pointer">
              <CloseIcon></CloseIcon>
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box className="mt-5">
          {requiredAction.feedBackRequired && (
            <div>
              <div className="pb-5">
                <FormControl className="w-full">
                  <InputLabel id="reaon">Select Feedback</InputLabel>
                  <Select
                    labelId="reaon"
                    name="reaon"
                    id="reaon"
                    value={feedback}
                    label="Select Feedback"
                    onChange={(event) => {
                      setFeedback(event.target.value);
                    }}
                    required
                  >
                    {requiredAction.feedBackList.map((ele) => (
                      <MenuItem value={ele}>{ele}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          )}

          {requiredAction.reasonRequired && (
            <div>
              <div className="pb-5">
                <FormControl className="w-full">
                  <InputLabel id="reaon">Select a Reason</InputLabel>
                  <Select
                    labelId="reaon"
                    name="reaon"
                    id="reaon"
                    value={reason}
                    label="Select a Reason"
                    onChange={(event) => {
                      setReason(event.target.value);
                    }}
                    required
                  >
                    {requiredAction.reasons.map((ele) => (
                      <MenuItem value={ele}>{ele}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              {reason === "Others" ? (
                <div className="pb-10">
                  <FormControl className="w-full">
                    <TextField
                      sx={{ fontSize: 14 }}
                      id="reasonOther"
                      label="Specify Reason*"
                      placeholder="Please specify the reason."
                      name="reasonOther"
                      onChange={(event) => setOtherReason(event.target.value)}
                      value={otherReason}
                    />
                  </FormControl>
                </div>
              ) : null}
            </div>
          )}

          {requiredAction.remarksRequired && (
            <div className="pb-10">
              <FormControl className="w-full">
                <TextField
                  sx={{ fontSize: 14 }}
                  id="remarks"
                  label="Remarks"
                  multiline
                  name="remarks"
                  onChange={(event) => setRemark(event.target.value)}
                  rows={4}
                  value={remark}
                />
              </FormControl>
            </div>
          )}

          <div className="pb-5 flex justify-between text-center">
            <div
              className="border border-gray-600 rounded-md w-40 text-gray-900 p-1 text-sm cursor-pointer font-semibold"
              type="submit"
              variant="contained"
              size="large"
              onClick={() => setActionDialogVisibility(false)}
            >
              <span>Cancel</span>
            </div>
            <button
              className={
                (requiredAction.reasonRequired && reason === "") ||
                (reason === "Others" && otherReason === "") ||
                (requiredAction.remarksRequired && requiredAction.remarksCompulsory && remark === "")
                  ? "border-gray-500 bg-gray-500 text-gray-100 border cursor-default rounded-md w-40 p-1 text-sm font-semibold"
                  : requiredAction.buttonClass
              }
              type="submit"
              variant="contained"
              size="large"
              disabled={
                (requiredAction.reasonRequired && reason === "") ||
                (reason === "Others" && otherReason === "") ||
                (requiredAction.remarksRequired && requiredAction.remarksCompulsory && remark === "")
              }
              onClick={() => updateRequest()}
            >
              <span>{requiredAction.buttonName}</span>
            </button>
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
